export default __webpack_public_path__ + "static/media/crazy_eights_screenshot.cf46ac3a.png";